export type LearningStage = "early" | "middle" | "teen";

export type StageProfile = {
  id: LearningStage;
  label: string;
  ageLabel: string;
  shortLabel: string;
  promise: string;
  designNote: string;
};

export const learningStages: Record<LearningStage, StageProfile> = {
  early: {
    id: "early",
    label: "Start in die Schule",
    ageLabel: "Klasse 1–2",
    shortLabel: "Klasse 1–2",
    promise: "Große Schritte, klare Aufgaben und viel Platz zum Denken.",
    designNote: "Kurze Texte · große Schaltflächen · sichtbare Erfolgsschritte",
  },
  middle: {
    id: "middle",
    label: "Selbstständig üben",
    ageLabel: "Klasse 3–6",
    shortLabel: "Klasse 3–6",
    promise: "Du entscheidest mit, probierst aus und siehst deinen nächsten Schritt.",
    designNote: "Klare Struktur · hilfreiche Hinweise · nicht kindisch",
  },
  teen: {
    id: "teen",
    label: "Sicher weiterkommen",
    ageLabel: "Klasse 7–10",
    shortLabel: "Klasse 7–10",
    promise: "Konzentriert lernen – mit Fachsprache, Überblick und eigenem Tempo.",
    designNote: "Ruhiges Arbeitswerkzeug · präzise Sprache · kein Leistungsdruck",
  },
};

export function learningStageForSkill(skill: string): LearningStage {
  const grade = Number(skill.match(/\.g(\d+)\./)?.[1]);
  if (grade >= 1 && grade <= 2) return "early";
  if (grade >= 3 && grade <= 6) return "middle";
  return "teen";
}
